export interface UMAProgram {
  /** Identifier used by the program picker on the UMA landing page. */
  slug: string
  /** URL segment for a dedicated program page. */
  routeSlug: string
  title: string
  shortTitle: string
  /** Value posted to the lead webhook as `mProgram`. */
  mProgram: string
}

export const umaPrograms: UMAProgram[] = [
  {
    slug: 'clinical-medical-assistant',
    routeSlug: 'as-clinical-medical-assistant',
    title: 'Associates in Clinical Medical Assistant',
    shortTitle: 'Clinical Medical Assistant',
    mProgram: 'HS-CMA',
  },
  {
    slug: 'medical-administrative-assistant',
    routeSlug: 'as-medical-administrative-assistant',
    title: 'Associates in Medical Administrative Assistant',
    shortTitle: 'Medical Administrative Assistant',
    mProgram: 'HS-MAA',
  },
  {
    slug: 'medical-billing-and-coding',
    routeSlug: 'as-medical-billing',
    title: 'Associates in Medical Billing & Coding',
    shortTitle: 'Medical Billing & Coding',
    mProgram: 'MBCOA',
  },
]

export function getUMAProgramByRouteSlug(
  routeSlug: string,
): UMAProgram | undefined {
  return umaPrograms.find((program) => program.routeSlug === routeSlug)
}
